const Dash = () => import("./Dash.vue");
import Layout from "../../Internal/Layout.vue";
// const Dashboard = () => import("./Dashboard/Dashboard.vue");

const DashRoutes = {
  component: Layout,
  children: [
    {
      path: "/dash-resale",
      name: "Dashboard",
      component: Dash,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
  ],
};

export default DashRoutes;
